import React from 'react';
import {Box} from 'src/design/atoms/Box';
import {SectionCard} from 'src/design/atoms/SectionCard';
import {ProactFormGrid} from 'src/app/forms/engine/ProactForm';
import {CONTENT_FIELD_NAME, CONTENT_PDF_FIELD_NAME} from './contentPdf';

export const ContentEditorSection: React.FC = () => (
  <SectionCard title="Content" data-testid="section-content">
    <Box p="md">
      <ProactFormGrid
        fieldNames={[CONTENT_FIELD_NAME, CONTENT_PDF_FIELD_NAME]}
        mb={0}
      />
    </Box>
  </SectionCard>
);
